import { createWebSocketStore } from 'src/components/#services/helpers';
export const getCategories = createWebSocketStore({
    auth: false,
    requestTemplate: {
        agent: 'blog',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'category_getAll',
    },
});
